import LoginTemplate from "../../../templates/users/login";

const LoginScreen = () => {
  return <LoginTemplate />;
};

export default LoginScreen;
